import { useOutletContext } from 'react-router-dom'

import { type PlanningPeriodDetailQuery } from 'generated/resources/graphql'

import { HeadcountEmployeeSheet } from 'modules/planning/components/Headcount/EmployeeSheet'
import type { PeriodRoleContext } from 'modules/planning/roles'

type PeriodDetailContext = {
  period: PlanningPeriodDetailQuery['planning']['period']
  periodId: string
  roleContext: PeriodRoleContext | undefined
}

const PeriodEmployeeSheetTab = () => {
  const { periodId, roleContext } = useOutletContext<PeriodDetailContext>()

  return <HeadcountEmployeeSheet periodId={periodId} roleContext={roleContext} />
}

export default PeriodEmployeeSheetTab
